// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21JzB","toggle":"styles_toggle__2wUOj","preview":"styles_preview__1c0YZ"};